import { render, staticRenderFns } from "./BitoChat.vue?vue&type=template&id=48f7d700&scoped=true&"
import script from "./BitoChat.vue?vue&type=script&lang=js&"
export * from "./BitoChat.vue?vue&type=script&lang=js&"
import style0 from "./BitoChat.vue?vue&type=style&index=0&id=48f7d700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7d700",
  null
  
)

export default component.exports